// Makes a product card's image area navigate to the product on click,
// as a JS-level guarantee alongside the .card__media-link <a> itself
// (snippets/card-product.liquid) — belt-and-suspenders in case any
// z-index/stacking-context interaction ever puts something else on top
// of that link and swallows the click before it reaches it.
document.addEventListener('click', (event) => {
  const media = event.target.closest('.card__media');
  if (!media) return;
  // Don't hijack clicks already headed to a real link/button inside the
  // media area (quick-add icon, zoom button, etc.).
  if (event.target.closest('a, button')) return;

  const link = media.querySelector('.card__media-link');
  if (link && link.href) {
    window.location.href = link.href;
  }
});
